module.exports = __webpack_public_path__ + "img/gb1239-1-12x14x145.prt.a486c92d.jpg";